<div class="my-5">
    <sm-page-header
        [breadcrumb]="breadcrumb"
        title="settings.dacScenarios.inspect.title">
    </sm-page-header>
    <div class="content">
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        <div class="mt-10">
            <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data || []" [loading]="loading"></sm-data-table-builder>
        </div>
    </div>
</div>
